import React from "react";

const bdppadLegend = [
  { color: "#ef3199", label: "Autres" },
  { color: "#2db3df", label: "Avoine" },
  { color: "#6fdebd", label: "Blé, triticale, épeautre" },
  { color: "#77d486", label: "CMA-Fruits" },
  { color: "#da5759", label: "CMA-Légumes divers" },
  { color: "#2bd3d0", label: "CMA-Multiples" },
  { color: "#46ca35", label: "CMA-Racines" },
  { color: "#926cd8", label: "CMA-Vivaces" },
  { color: "#c6d14a", label: "Foin" },
  { color: "#e20dbf", label: "Inconnu" },
  { color: "#dc416d", label: "Légumes de transformation" },
  { color: "#cb4c1d", label: "Maïs fourrager" },
  { color: "#5673e5", label: "Maïs-grain" },
  { color: "#caa478", label: "Multiples" },
  { color: "#5994d3", label: "Orge" },
  { color: "#ade589", label: "Petits fruits" },
  { color: "#665cd9", label: "Pommes" },
  { color: "#cd6ed8", label: "Pommes de terre" },
  { color: "#decc84", label: "Protéagineuses" },
  { color: "#badc7a", label: "Seigle" },
  { color: "#9923dd", label: "Soya" },
  { color: "#57ce8b", label: "DESGROPRO is ''" }
];

export default function AgricoleLegend({ layer }) {
  if (!layer || !layer.toLowerCase().includes("bdppa")) return null;

  return (
    <div className="legend-panel" style={{
      padding: "1em",
      background: "#fff",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      marginTop: "1em",
      wordBreak: "break-word",
      whiteSpace: "pre-line",
      width: "180px",
      minWidth: "140px",
      height: "auto",
      maxHeight: "none",
      overflow: "visible",
      position: "static"
    }}>
      <h4 style={{
        margin: "0 0 0.5em 0",
        color: "#232b21",
        fontSize: "1em",
        wordBreak: "break-word"
      }}>
        Légende BDPPA
      </h4>
      <ul style={{
        listStyle: "none",
        padding: 0,
        margin: 0,
        wordBreak: "break-word"
      }}>
        {bdppadLegend.map((item, idx) => (
          <li key={idx} style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "0.5em",
            wordBreak: "break-word"
          }}>
            <span
              style={{
                display: "inline-block",
                width: "22px",
                height: "14px",
                background: item.color,
                border: "1px solid #232b21",
                borderRadius: "3px",
                marginRight: "0.7em"
              }}
            ></span>
            <span style={{
              color: "#232b21",
              fontSize: "0.85em",
              wordBreak: "break-word"
            }}>{item.label}</span>
          </li>
        ))}
      </ul>
      <div style={{
        marginTop: "0.5em",
        fontSize: "0.85em",
        color: "#666",
        wordBreak: "break-word"
      }}>
        Couche active : <b>{layer}</b>
      </div>
    </div>
  );
}